angular.module('taric.duty', [])
    .factory('dutyDataService', require('./services/duty-data'))
    ;

